import React, {Component} from 'react';
import GlobalVariable from '../../GlobalVariable';
import api from '../../api';
import Menu from '../Menu';
import PageHeader from '../PageHeader';
import Preloader from '../Preloader';
import PlanDemo from './PlanDemo';

class Planning extends Component<any, any> {
    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            isLoad: false,
            error: '',
            dashboard: null,
        };
    }

    componentDidMount() {
        this.fetchDashboard();
    }

    fetchDashboard = () => {
        this.setState({isLoad: false, error: ''});
        api({
            url: GlobalVariable.host() + '/widget/staff/v2/planning/dashboard',
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
        }).then((result) => {
            this.setState({dashboard: result.data, isLoad: true});
        }).catch((error) => {
            if (error?.response?.data?.error === 'staff_profile_not_found') {
                this.setState({isLoad: true, error: 'План появится, когда профиль мастера будет привязан к вашему аккаунту. Если вы уже работаете в салоне, попросите управляющего проверить привязку.'});
                return;
            }
            if (error?.response?.status === 401) {
                window.location.href = '/start';
                return;
            }
            this.setState({isLoad: true, error: 'Не удалось обновить план. Попробуйте ещё раз чуть позже.'});
        });
    };

    money = (value: any) => `${Number(value || 0).toLocaleString('ru-RU')} ₽`;

    renderForecast() {
        const forecast = this.state.dashboard?.forecast;
        if (!forecast) {
            return null;
        }

        return (
            <div className='chio-card ml-3 mr-3 mb-3 p-3'>
                <div className='txt-large bold mb-2'>Прогноз</div>
                <div className='txt-middle mb-2'>{forecast.text}</div>
                {(forecast.items || []).map((item: any, index: number) => (
                    <div key={`${item.title}-${index}`} className='d-flex justify-content-between txt-middle'>
                        <span>{Number(item.count || 1) > 1 ? `${item.count} x ${item.title}` : item.title}</span>
                        <span>{this.money(item.price)}</span>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        if (!this.state.isLoad) {
            return <Preloader/>;
        }

        if (this.state.error) {
            return <div className='main planning'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Планирование' backBtnUrl='/'/>
                    <div className='pt-header'/>
                    <div className='chio-card ml-3 mr-3 mt-3 p-3 txt-middle'>
                        {this.state.error}
                        {this.state.error.startsWith('Не удалось') &&
                            <button type='button' className='d-block mt-3' onClick={this.fetchDashboard}>Повторить</button>}
                    </div>
                </div>
                <Menu/>
            </div>;
        }

        const data = this.state.dashboard || {};
        const progress = data.progress || {};
        const plan = data.plan || {};
        const hasPlan = Number(plan.amount || 0) > 0;
        const income = data.income || {};
        const shift = data.shift || {};
        const percent = Math.min(140, Number(progress.percent || 0));

        return (
            <div className='main planning'>
                <div className='content mx-w-content'>
                    <PageHeader pageTitle='Планирование' backBtnUrl='/'/>
                    <div className='pt-header'></div>

                    <div className='chio-card ml-3 mr-3 mt-3 mb-3 p-3'>
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <div>
                                <div className='txt-large bold'>План на сегодня</div>
                                <div className='txt-small'>{data.company?.address || data.company?.title || ''}</div>
                            </div>
                            {hasPlan ? <div className='txt-large bold'>{progress.percent || 0}%</div> : null}
                        </div>
                        {hasPlan ? <>
                            <div style={{height: 10, background: '#f0f0f0', borderRadius: 8, overflow: 'hidden'}}>
                                <div style={{width: `${percent}%`, height: '100%', background: '#e72f44', borderRadius: 8}}/>
                            </div>
                            <div className='d-flex justify-content-between mt-2 txt-middle'>
                                <span>Моя выручка: {this.money(progress.revenue)}</span>
                                <span>{this.money(plan.amount)}</span>
                            </div>
                            {progress.hint ? <div className='txt-small mt-2'>{progress.hint}</div> : null}
                        </> : <>
                            <div className='txt-small mt-3'>Моя выручка за сегодня</div>
                            <div className='txt-large bold'>{this.money(progress.revenue)}</div>
                            <div className='txt-middle mt-3' style={{color: '#314863', lineHeight: 1.45}}>
                                План подскажет, сколько ещё стрижек или окрашиваний нужно до цели смены. Пока он не задан, выручка и услуги всё равно учитываются.
                            </div>
                            <PlanDemo/>
                        </>}
                    </div>

                    <div className='d-flex ml-3 mr-3 mb-3'>
                        <div className='chio-card p-3 mr-2 w-50'>
                            <div className='txt-small'>Мой заработок за сегодня</div>
                            <div className='txt-large bold'>{this.money(income.amount)}</div>
                        </div>
                        <div className='chio-card p-3 ml-2 w-50'>
                            <div className='txt-small'>Смены</div>
                            <div className='txt-large bold'>{shift.workedThisMonth || 0}/{shift.plannedThisMonth || 0}</div>
                        </div>
                    </div>

                    {(income.parts || []).length ? (
                        <div className='chio-card ml-3 mr-3 mb-3 p-3'>
                            <div className='txt-large bold mb-2'>Оказанные услуги</div>
                            {(income.parts || []).map((item: any, index: number) => (
                                <div key={`${item.title}-${index}`} className='d-flex justify-content-between txt-middle mb-1'>
                                    <span>{item.title}</span>
                                    <span>{this.money(item.paid)}</span>
                                </div>
                            ))}
                        </div>
                    ) : null}

                    {hasPlan ? this.renderForecast() : null}

                    <div className='chio-card ml-3 mr-3 mb-3 p-3'>
                        <div className='txt-large bold mb-2'>Чикоины</div>
                        <div className='txt-middle'>+1 за первый заход в день</div>
                        {hasPlan ? <>
                            <div className='txt-middle'>+5 за выполнение плана</div>
                            <div className='txt-middle'>+10 за перевыполнение на 20%+</div>
                        </> : <div className='txt-middle mt-2'>Бонусы за выполнение плана доступны, когда задана цель на день.</div>}
                    </div>

                </div>
                <Menu/>
            </div>
        );
    }
}

export default Planning;
